<template>
        
          <v-text-field
            v-model="text"
            :append-icon="show ? 'visibility' : 'visibility_off'"
            :type="show ? 'text' : 'password'"
            readonly
            class="wrapped-static"
            @click:append="show = !show"
          ></v-text-field>

</template>

<script>
  export default {
    props: ["text"],
    data () {
      return {
        show: false,
      }
    }
  }
</script>
<style>
  .wrapped-static {
    max-width: 100px;
    min-width: 100px;
  }
  
</style>
